import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { CCol, CRow, CContainer, CDropdownDivider } from '@coreui/react'
import {
  AppContentSitio,
  AppFooter,
  AppHeaderSitio,
  AppSidebarNavSitios,
} from '../components/index'
import api from 'src/api/api'

const SubmenuSitiosLayout = () => {
  const { sitio } = useParams()
  /**
   * Por alguna razón const { id } = useParams()
   * trae lo que esta definido como :ruta en routerSitios.js.
   * Con ese dato vamos a buscar los datos del menú superior
   * y los pares para armar el submenú.
   */
  const { id } = useParams()
  const [nav, setNav] = useState([])
  const [titulo, setTitulo] = useState('')
  const basePath = String(process.env.PUBLIC_URL).trim()

  useEffect(() => {
    if (sitio && id)
      api.sitiosSubmenu({ sitio: sitio, url: id }).then((response) => {
        setNav(response.data.data.items)
        setTitulo(response.data.data.menu.descripcion)
      })
  }, [])

  return (
    <div>
      <div className="wrapper d-flex flex-column min-vh-100">
        <AppHeaderSitio id={id} sitio={sitio} />
        <div className="body flex-grow-1 mb-5">
          <CContainer fluid className="container-er">
            <CRow className="mb-2 mt-0">
              <div className="encabezado-paginas-sitios">{titulo}</div>
              <CCol>
                <CDropdownDivider></CDropdownDivider>
              </CCol>
            </CRow>
            <CRow className="d-none d-md-flex">
              <CCol lg={3} md={4}>
                <AppSidebarNavSitios items={nav} base={basePath + '/' + sitio} />
              </CCol>
              <CCol lg={9} md={8}>
                <AppContentSitio sitio={sitio} />
              </CCol>
            </CRow>
            <CRow className="d-xs-flex d-sm-flex d-md-none">
              <CCol xs={12}>
                <AppContentSitio sitio={sitio} />
              </CCol>
            </CRow>
          </CContainer>
        </div>
        <AppFooter sitio={sitio} home={false} />
      </div>
    </div>
  )
}

export default SubmenuSitiosLayout
